import { c as _c } from "react/compiler-runtime";
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { Badge } from '@sola/ark-core/atoms/badge/badge.tsx';
import { ItemCardBody, ItemCardMeta, ItemCardSection, ItemCardSummary } from '@sola/ark-core/molecules/item-card/item-card.tsx';
import { GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { getCommitmentLabel, getCommitmentTitle, getFrequencyAbbr } from '@sola/supporter-sdk/utils/commitments.ts';
import { CommitmentAvatar } from '../../atoms/commitment-avatar/commitment-avatar.tsx';
const useComponentData = args => {
  const $ = _c(25);
  const {
    commitment,
    t
  } = args;
  let t0;
  if ($[0] !== commitment) {
    t0 = <CommitmentAvatar responsive={true} commitment={commitment} />;
    $[0] = commitment;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const icon = t0;
  let t1;
  if ($[2] !== commitment || $[3] !== t) {
    t1 = getCommitmentTitle(commitment, t);
    $[2] = commitment;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const title = t1;
  let t2;
  if ($[5] !== commitment || $[6] !== t) {
    t2 = getCommitmentLabel(commitment, t);
    $[5] = commitment;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const label = t2;
  const t3 = commitment?.rate;
  let t4;
  if ($[8] !== t || $[9] !== t3) {
    t4 = t("numbers.currencyCustom", {
      amount: t3,
      useNegativeParens: true
    });
    $[8] = t;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const rate = t4;
  const missedAmount = (commitment.dueThisMonthAmount || 0) + (commitment.missedPaymentAmount || 0);
  let t5;
  if ($[11] !== missedAmount || $[12] !== t) {
    t5 = missedAmount > 0 ? t("numbers.currencyCustom", {
      amount: missedAmount,
      useNegativeParens: true
    }) : undefined;
    $[11] = missedAmount;
    $[12] = t;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== commitment.frequency || $[15] !== t) {
    t6 = commitment?.frequency ? getFrequencyAbbr(commitment.frequency, t) : undefined;
    $[14] = commitment.frequency;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== commitment.hasMissedPayment || $[18] !== icon || $[19] !== label || $[20] !== rate || $[21] !== t5 || $[22] !== t6 || $[23] !== title) {
    t7 = {
      totalMissedAmount: t5,
      hasMissedPayment: commitment.hasMissedPayment,
      frequencyAbbr: t6,
      icon,
      title,
      label,
      rate
    };
    $[17] = commitment.hasMissedPayment;
    $[18] = icon;
    $[19] = label;
    $[20] = rate;
    $[21] = t5;
    $[22] = t6;
    $[23] = title;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
export interface CommitmentCardInfoSectionProps {
  commitment: GraphQLCommitment;
  useRate?: boolean;
}
export const CommitmentCardInfoSection: React.FC<CommitmentCardInfoSectionProps> = t0 => {
  const $ = _c(18);
  const {
    commitment,
    useRate: t1
  } = t0;
  const useRate = t1 === undefined ? true : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["my"];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation(t2);
  let t3;
  if ($[1] !== commitment || $[2] !== t) {
    t3 = {
      t,
      commitment
    };
    $[1] = commitment;
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    icon,
    title,
    label,
    rate,
    frequencyAbbr,
    hasMissedPayment,
    totalMissedAmount
  } = useComponentData(t3);
  let t4;
  if ($[4] !== icon || $[5] !== label || $[6] !== title) {
    t4 = <ItemCardSummary icon={icon} title={title} subTitle={label} />;
    $[4] = icon;
    $[5] = label;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = useRate ? rate : totalMissedAmount;
  const t6 = useRate ? frequencyAbbr : undefined;
  let t7;
  if ($[8] !== hasMissedPayment || $[9] !== t) {
    t7 = hasMissedPayment ? <Badge label={t("my:commitments.missedPaymentsLabel")} color="negative" responsive={true} /> : undefined;
    $[8] = hasMissedPayment;
    $[9] = t;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t5 || $[12] !== t6 || $[13] !== t7) {
    t8 = <ItemCardMeta text={t5} textContrast={t6} badge={t7} />;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t4 || $[16] !== t8) {
    t9 = <ItemCardSection><ItemCardBody>{t4}{t8}</ItemCardBody></ItemCardSection>;
    $[15] = t4;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  return t9;
};